import { Text, TextProps } from "@chakra-ui/react";
import { PropsWithChildren } from "react";

export const BodyText = ({ children, ...props }: PropsWithChildren & TextProps) => (
  <Text fontWeight="500" fontSize="lg" color="fg.muted" {...props}>
    {children}
  </Text>
);
